module.exports = __webpack_public_path__ + "img/bilibili_banner.9291cf43.png";